import * as React from 'react'

import DashboardUser from './dashboard/DashboardUser'

import Navbar from '../components/Navbar'
import StyledContainer from '../components/StyledContainer'

const Dashboard: React.SFC = () => (
  <div>
    <Navbar />
    <StyledContainer>
      <DashboardUser />
    </StyledContainer>
  </div>
)

export default Dashboard



// WEBPACK FOOTER //
// ./src/screens/MyLoans.tsx